import { render, staticRenderFns } from "./quotation-detail-form.vue?vue&type=template&id=15e8881f"
import script from "./quotation-detail-form.vue?vue&type=script&lang=js"
export * from "./quotation-detail-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports